const LABELS = {
  aracCinsi: "Arac Cinsi",
  bomUzunlugu: "Bom Uzunlugu",
  bomUzunluğu: "Bom Uzunlugu",
  cikisKm: "Cikis KM",
  createdAt: "Olusturma Tarihi",
  date: "Tarih",
  deltaKm: "Fark KM",
  donusKm: "Donus KM",
  driverId: "Surucu ID",
  driverName: "Surucu",
  faturaNo: "Fatura No",
  fiiliKm: "Fiili KM",
  fiiliM3: "Fiili m3",
  fisNo: "Fis No",
  fişNo: "Fis No",
  liters: "Litre",
  marka: "Marka",
  mikserFirmasi: "Mikser Firmasi",
  mikserPlaka: "Mikser Plaka",
  model: "Model",
  musteriAdi: "Musteri",
  odometerKm: "Kilometre",
  operator: "Operator",
  operatorAdi: "Operator",
  personelAdi: "Personel",
  personelGorevi: "Gorev",
  plaka: "Plaka",
  plate: "Plaka",
  pompaFirmasi: "Pompa Firmasi",
  pompaPlaka: "Pompa Plaka",
  receiptNo: "Fis No",
  santiyeAdi: "Santiye",
  soforAdi: "Sofor",
  tarih: "Tarih",
  teslimSekli: "Teslim Sekli",
  tesis: "Tesis",
  Tesis: "Tesis",
  "Tesis_Adı": "Tesis",
  uretimM3_zone: "Uretim m3",
  ustGrupMarka: "Ust Grup Marka",
  ustGrupModel: "Ust Grup Model",
  updatedAt: "Guncelleme Tarihi",
  vehiclePlate: "Plaka",
  vehicleTesis: "Tesis",
  vehicleType: "Arac Tipi",
  votoKm: "Voto KM",
  yagciAdi: "Yagci"
};

const normalizeTurkishText = (value = "") =>
  String(value)
    .replace(/Ä±/g, "ı")
    .replace(/Ä°/g, "I")
    .replace(/ÄŸ/g, "g")
    .replace(/Äž/g, "G")
    .replace(/Ã¼/g, "u")
    .replace(/Ãœ/g, "U")
    .replace(/ÅŸ/g, "s")
    .replace(/Åž/g, "S")
    .replace(/Ã¶/g, "o")
    .replace(/Ã–/g, "O")
    .replace(/Ã§/g, "c")
    .replace(/Ã‡/g, "C");

const humanize = (field = "") => {
  const clean = normalizeTurkishText(field).split(".").pop() || field;
  return clean
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, char => char.toLocaleUpperCase("tr-TR"));
};

export const getFieldLabel = (field) => {
  const key = String(field || "");
  return LABELS[key] || LABELS[normalizeTurkishText(key)] || humanize(key);
};

export default getFieldLabel;
